import {makeObservable, observable} from "mobx";

import {BaseWidgetDisplayModel} from "../../models/base-widget-display-model";

export class AppPrivacyDisplayModel extends BaseWidgetDisplayModel {
  @observable source: String;

  constructor() {
    super();

    this.source = null;

    makeObservable(this)
  }
}
